var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6118 5.49244L14.9853 8.21228L15.0013 8.06981C15.0013 6.64081 13.5609 5.47949 11.7885 5.47949L11.6118 5.49244Z",
    fill: "#656565"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7882 3.75234C14.7451 3.75234 17.1449 5.68646 17.1449 8.06955C17.1449 8.62647 17.0057 9.15749 16.7646 9.64532L19.8983 12.1709C21.516 11.0829 22.7909 9.67555 23.5783 8.06955C21.7196 4.27906 17.1503 1.59375 11.7883 1.59375C10.2884 1.59375 8.85286 1.8096 7.51904 2.19814L9.83313 4.05884C10.4384 3.8689 11.0972 3.75234 11.7882 3.75234Z",
    fill: "#656565"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.07522 1.39923L3.51787 3.36787L4.00534 3.76075C2.23764 4.87459 0.839548 6.3554 0.00390625 8.0693C1.85733 11.8598 6.43192 14.5451 11.7886 14.5451C13.4492 14.5451 15.0348 14.2861 16.4864 13.8155L16.9418 14.1825L20.0647 16.7037L21.4307 15.6071L2.44118 0.29834L1.07522 1.39923ZM6.99974 6.16975L8.65495 7.50376C8.60674 7.68942 8.5746 7.87503 8.5746 8.0693C8.5746 9.49831 10.0155 10.6596 11.7886 10.6596C12.0297 10.6596 12.26 10.6337 12.485 10.5949L14.1402 11.9289C13.4278 12.2138 12.635 12.3865 11.7886 12.3865C8.83173 12.3865 6.43192 10.4524 6.43192 8.0693C6.43192 7.3872 6.6462 6.74824 6.99974 6.16975Z",
    fill: "#656565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.761ce8a017ce449722c8fa0f98c5725a.svg";
export { ForwardRef as ReactComponent };